import { Space } from "antd";
import EventsComponent from "./Events";
import PlayerComponent from "./Player";
import OrganizersComponent from "./Organizers";
import TeamsComponent from "./Teams";
import PanelsComponent from "./Panels";
import React, { Fragment, useState } from "react";
import Loader from "../../../common/cards/Loader";
// import NoData from "../../../common/cards/noData";
import { ROLES } from "../../../Config/helpers/constants";

function SearchPageMain({ active, loading, allSearchData, setactive, setFilter, filter }) {
  const [selectedEventOptions, setSelectedEventOptions] = useState({
    registrationStatus: false,
    allowWildCard: false,
    sponsors: false,
    prizeMoney: false
  });

  const [selectedPlayerOptions, setSelectedPlayerOptions] = useState({
    sponsors: false,
    eventsParticipated: null,
    awardWin: null
  });

  const [selectedOrganizerOptions, setSelectedOrganizerOptions] = useState({
    eventsOrganized: null,
    sponsors: false
  });

  const [selectedTeamOptions, setSelectedTeamOptions] = useState({
    eventsParticipated: null,
    awardWin: null,
    sponsors: false
  });

  const [selectedPanelOptions, setSelectedPanelOptions] = useState({
    eventsOrganized: null,
    sponsors: false,
    rating: null
  });

  const handleEventChange = (name, checked) => {
    setSelectedEventOptions((prev) => ({ ...prev, [name]: checked }));
    setFilter((prev) => ({ ...prev, [name]: checked }));
  };

  const handlePlayerChange = (name, checked) => {
    setSelectedPlayerOptions((prev) => ({ ...prev, [name]: checked }));
    setFilter((prev) => ({ ...prev, [name]: checked }));
  };

  const handleOrganizerChange = (name, checked) => {
    setSelectedOrganizerOptions((prev) => ({ ...prev, [name]: checked }));
    setFilter((prev) => ({ ...prev, [name]: checked }));
  };

  const handleTeamChange = (name, checked) => {
    setSelectedTeamOptions((prev) => ({ ...prev, [name]: checked }));
    setFilter((prev) => ({ ...prev, [name]: checked }));
  };

  const handlePanelChange = (name, checked) => {
    setSelectedPanelOptions((prev) => ({ ...prev, [name]: checked }));
    setFilter((prev) => ({ ...prev, [name]: checked }));
  };

  const handleResetFilters = (state) => {
    const updatedFiltersOption = { ...filter };

    delete updatedFiltersOption.sponsors;
    if (state === "event") {
      delete updatedFiltersOption.registrationStatus;
      delete updatedFiltersOption.allowWildCard;
      delete updatedFiltersOption.prizeMoney;
      delete updatedFiltersOption.date;
      setSelectedEventOptions(updatedFiltersOption);
    } else if (state === "panel") {
      delete updatedFiltersOption.rating;
      delete updatedFiltersOption.eventsOrganized;
      setSelectedPanelOptions(updatedFiltersOption);
    } else if (state === "team") {
      delete updatedFiltersOption.awardWin;
      delete updatedFiltersOption.eventsParticipated;
      setSelectedTeamOptions(updatedFiltersOption);
    } else if (state === "player") {
      delete updatedFiltersOption.awardWin;
      delete updatedFiltersOption.eventsParticipated;
      setSelectedPlayerOptions(updatedFiltersOption);
    } else if (state === "organizer") {
      delete updatedFiltersOption.eventsOrganized;
      delete updatedFiltersOption.rating;
      setSelectedOrganizerOptions(updatedFiltersOption);
    }
    setFilter(updatedFiltersOption);
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      {loading ? <Loader /> : null}

      {active === ROLES.event && !loading ? (
        <Fragment>
          <EventsComponent
            setactive={setactive}
            Events={allSearchData}
            loading={loading}
            setFilter={setFilter}
            resetFilter={handleResetFilters}
            selectedOptions={selectedEventOptions}
            handleCheckboxChange={handleEventChange}
          />
        </Fragment>
      ) : null}
      {active === ROLES.player && !loading ? (
        <Fragment>
          <PlayerComponent
            setactive={setactive}
            Players={allSearchData}
            loading={loading}
            setFilter={setFilter}
            selectedOptions={selectedPlayerOptions}
            resetFilter={handleResetFilters}
            handleCheckboxChange={handlePlayerChange}
          />
        </Fragment>
      ) : null}
      {active === ROLES.organizer && !loading ? (
        <Fragment>
          <OrganizersComponent
            setactive={setactive}
            Organizers={allSearchData}
            loading={loading}
            setFilter={setFilter}
            selectedOptions={selectedOrganizerOptions}
            resetFilter={handleResetFilters}
            handleCheckboxChange={handleOrganizerChange}
          />
        </Fragment>
      ) : null}
      {active === ROLES.team && !loading ? (
        <Fragment>
          <TeamsComponent
            setactive={setactive}
            Teams={allSearchData}
            loading={loading}
            setFilter={setFilter}
            selectedOptions={selectedTeamOptions}
            resetFilter={handleResetFilters}
            handleCheckboxChange={handleTeamChange}
          />
        </Fragment>
      ) : null}
      {active === ROLES.panel && !loading ? (
        <Fragment>
          <PanelsComponent
            setactive={setactive}
            Panels={allSearchData}
            loading={loading}
            setFilter={setFilter}
            filter={filter}
            selectedOptions={selectedPanelOptions}
            resetFilter={handleResetFilters}
            handleCheckboxChange={handlePanelChange}
          />
        </Fragment>
      ) : null}
    </Space>
  );
}

export default SearchPageMain;
